// extracted by mini-css-extract-plugin
export default {"catalog-carousel-section":"catalog-carousel_catalog-carousel-section__zRwGV","catalog-carousel":"catalog-carousel_catalog-carousel__fAGjY"};